// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.material-icons{ line-height: 9px; top: 7px; cursor: pointer }`, "",{"version":3,"sources":["webpack://./src/app/components/sort-arrow/SortArrowCmp.ts"],"names":[],"mappings":"AAAA,iBAAiB,gBAAgB,EAAE,QAAQ,EAAE,gBAAgB","sourcesContent":[".material-icons{ line-height: 9px; top: 7px; cursor: pointer }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
